import React, { useEffect, useState } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';

import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import globalTranslations from '../../../../i18n/globalTranslations';
import AddressBookForm from '../AddressBookForm';

const AddressBookModal = ({ isOpen, toggle, onSave, loading }) => {
  const [serverErrors, setServerErrors] = useState({});

  useEffect(() => {
    if (isOpen) {
      setServerErrors({});
    }
  }, [isOpen]);

  const handleCancel = () => {
    toggle();
  };

  const handleSave = (payload) => {
    const result = onSave(payload);
    if (result && typeof result.then === 'function') {
      result
        .then(() => {
          setServerErrors({});
          toggle();
        })
        .catch((err) => {
          const errors = err?.response?.data?.errors;
          setServerErrors(errors && typeof errors === 'object' ? errors : {});
        });
    } else {
      toggle();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      className="AddressBookModal"
      backdrop="static"
    >
      <ModalHeader toggle={toggle} className="AddressBookModal__header">
        <FormattedMessage {...globalTranslations.recipientInformationTitle} />
      </ModalHeader>
      <ModalBody className="AddressBookModal__body">
        <AddressBookForm
          onSave={handleSave}
          onCancel={handleCancel}
          loading={loading}
          serverErrors={serverErrors}
        />
      </ModalBody>
    </Modal>
  );
};

AddressBookModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

export default AddressBookModal;
